// extracted by mini-css-extract-plugin
export default {"power":"Power_power__zW9Mo","content":"Power_content__cUJYf"};